export const initialExerciseProgress = {
   currentLevel: 1,
   tutorialComplete: false,
   sessionHistory: [],
};
